<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.rrn') }}
        </div>
        <div class="transaction-item-info__value">{{ transaction.rrn }}</div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.client-ip') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.browserIp }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.lastname') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.userFullName.lastname }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.pan') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.cardNumber }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.firstname') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.userFullName.firstname }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.bank') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.bankName }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.middlename') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.userFullName.middlename }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.payment-tool') }}
        </div>
        <div class="transaction-item-info__value">
          <transaction-pay-tool
            :pay-tool="transaction.payType"
          ></transaction-pay-tool>
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.email') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.userEmail }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.payment-system') }}
        </div>
        <div class="transaction-item-info__value">
          <transaction-pay-system
            :pay-system="transaction.paySystem"
          ></transaction-pay-system>
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.phone') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.userPhone }}
        </div>
      </div>
      <div class="transaction-item-info__group"></div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.card-client-info.ipn') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.ipn }}
        </div>
      </div>
      <div class="transaction-item-info__group"></div>
    </div>
  </div>
</template>

<script>
import TransactionPayTool from '@vue-app/components/transaction/TransactionPayTool.vue'
import TransactionPaySystem from '@vue-app/components/transaction/TransactionPaySystem.vue'

import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemCardClientInfo',
  components: { TransactionPaySystem, TransactionPayTool },
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
